<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { api } from '~/api/apis'

useHead({
  bodyAttrs: {
    class: 'app'
  }
})

const unsubscribeEmail = ref('')

const route = useRoute()

const { locale } = useI18n()

const commonStore = useCommonStore()
const { loading, snack } = storeToRefs(commonStore)

/** 判斷是否為英文 */
const isEn = computed(() => {
  return route.fullPath.includes('/en')
})

/** route 名稱 */
const routeName = computed((): string => {
  if (typeof route.name === 'string') {
    const match = route.name.match(/(?:(?!___).)*/)
    return match ? match[0] : ''
  }
  return ''
})

const bgClass = computed(() => {
  return [
    'index',
    'forget',
    'registered',
    'sign',
    'submit',
    'registered-edit'
  ].includes(routeName.value)
    ? { 'sign-bg': true }
    : { 'white-bg': true }
})

const noPt = computed(() => {
  return routeName.value === 'index'
})

function onUnsubscribe() {
  const payload = {
    email: unsubscribeEmail.value,
    languages: locale.value === 'tw' ? 'TW' : 'EN',
    sourceType: 'portal'
  }
  $('#cancelModal').modal('hide')

  api.postUnsubscribe(payload).then(() => {
    $('#unsubscribeModal').modal('show')
  })
}

watch(
  () => route.path,
  () => {
    const ele = document.querySelector('.modal-backdrop.fade.show')
    setTimeout(() => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }, 100)
    if (ele) {
      ele.remove()
    }
  }
)
</script>

<template>
  <div>
    <div class="wrapper" :class="{ ...bgClass, 'pt-0': noPt }">
      <client-only>
        <app-loading :data="loading" />
      </client-only>
      <app-nav />
      <slot></slot>
      <common-snack-bar v-if="snack.message" :data="snack" />
    </div>
    <app-footer />
    <!-- Model -->
    <div
      v-if="isEn"
      id="exampleModalCenter"
      aria-hidden="true"
      aria-labelledby="exampleModalCenterTitle"
      class="modal fade privacy"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1rem">
          <div class="modal-body">
            I agree to the TPIsoftware
            <a
              class="text-primary"
              href="/pdf/1-2PrivacyPolicy(en).pdf"
              target="_blank"
            >
              <u>Privacy Policy</u>
            </a>
            and that this website may use my personal data to send
            communications to me about TPIsoftware services. I understand that I
            can
            <a
              class="text-primary"
              data-dismiss="modal"
              data-target="#cancelModal"
              data-toggle="modal"
            >
              <u>unsubscribe</u>
            </a>
            at any time.
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              data-dismiss="modal"
              type="button"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Model -->
    <div
      v-else
      id="exampleModalCenter"
      aria-hidden="true"
      aria-labelledby="exampleModalCenterTitle"
      class="modal fade privacy"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1rem">
          <div class="modal-body">
            當您輸入電子信箱、訂閱本公司之「電子報」時，我們會向您蒐集、處理
            、利用的個資為您的「電子信箱」以及「提交日期」，當您輸入電子信箱
            並送出時，即表示您同意我們使用您的個資，為保障您的權益，關於更多
            相關政策更新資訊，請務必閱讀我們的「
            <a
              class="text-primary"
              href="/pdf/1-1PrivacyPolicy(tw).pdf"
              target="_bank"
            >
              <u>隱私權政策</u>
            </a>
            」、「
            <a class="text-primary" href="/pdf/2-1Use(tw).pdf" target="_bank">
              <u>使用條款</u>
            </a>
            」及「
            <a
              class="text-primary"
              href="/pdf/3-1Disclaimer(tw).pdf"
              target="_bank"
            >
              <u>免責聲明</u>
            </a>
            」。如您不同意本網站之「隱私權政策」、「使用條款」及「
            免責聲明」，您可以隨時「
            <a
              class="text-primary"
              data-dismiss="modal"
              data-target="#cancelModal"
              data-toggle="modal"
            >
              <u>取消訂閱</u>
            </a>
            」，謝謝您。
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              data-dismiss="modal"
              type="button"
            >
              關閉
            </button>
          </div>
        </div>
      </div>

      <!-- Modal 確認訂閱電子報 -->
      <div
        id="subscribeModal"
        aria-hidden="true"
        aria-labelledby="subscribeModalTitle"
        class="modal fade privacy"
        role="dialog"
        tabindex="-1"
      >
        <div
          class="modal-lg modal-dialog modal-dialog-centered"
          role="document"
        >
          <div class="modal-content" style="border-radius: 1rem">
            <div class="modal-header text-center">
              <h3>{{ $t('nav_subscribe_title') }}</h3>
            </div>
            <div class="modal-body text-center">
              <p>{{ $t('nav_subscribe_word') }}</p>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-secondary"
                data-dismiss="modal"
                type="button"
              >
                {{ $t('nav_subscribe_close') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Model 取消訂閱 -->
      <div
        id="cancelModal"
        aria-hidden="true"
        aria-labelledby="cancelModalTitle"
        class="modal fade privacy"
        role="dialog"
        tabindex="-1"
      >
        <div
          class="modal-lg modal-dialog modal-dialog-centered"
          role="document"
        >
          <form
            class="modal-content"
            style="border-radius: 1rem"
            @submit.prevent="onUnsubscribe"
          >
            <div class="modal-body">
              <div class="unsubscribe">
                <span class="unsub-word">
                  {{ $t('nav_unsubscribe') }}
                </span>
                <div class="sub-input">
                  <div class="w-100">
                    <input
                      v-model="unsubscribeEmail"
                      class="form-control"
                      type="email"
                      required
                      :placeholder="$t('nav_unsubscribe_placeholder')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-unsub" type="submit">
                {{ $t('nav_unsubscribe_submit') }}
              </button>
              <button
                class="btn btn-secondary"
                data-dismiss="modal"
                type="button"
              >
                {{ $t('nav_unsubscribe_cancel') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Unsubscribe Modal -->
    <div
      id="unsubscribeModal"
      aria-hidden="true"
      aria-labelledby="unsubscribeModalTitle"
      class="modal fade privacy"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1rem">
          <div class="modal-body text-center">
            <h3>{{ $t('nav_unsubscribe_window_title') }}</h3>
            <p>
              {{ $t('nav_unsubscribe_window_word') }}
            </p>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              data-dismiss="modal"
              type="button"
            >
              {{ $t('nav_unsubscribe_window_close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '~/assets/app/scss/index';
</style>
